import { render, staticRenderFns } from "./holiday-logos-view.vue?vue&type=template&id=7f20c18c&"
import script from "./holiday-logos-view.vue?vue&type=script&lang=ts&"
export * from "./holiday-logos-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports